import { render, staticRenderFns } from "./_parcels.vue?vue&type=template&id=cbe69fe2&scoped=true&"
import script from "./_parcels.vue?vue&type=script&lang=js&"
export * from "./_parcels.vue?vue&type=script&lang=js&"
import style0 from "./_parcels.vue?vue&type=style&index=0&id=cbe69fe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe69fe2",
  null
  
)

export default component.exports